import { useThemesStore } from './store';
import { ColorScheme, ThemeConfig } from './types';

export const actionsCreator = ({
  setState
}: {
  setState: (data: (prevState: ThemeConfig) => ThemeConfig) => void;
}) => {
  return {
    SET_COLOR_SCHEME: (colorScheme: ColorScheme) => {
      setState((prevState) => ({
        ...prevState,
        colorScheme: {
          ...prevState.colorScheme,
          ...colorScheme
        }
      }));
    }
  };
};

export const themesStoreActions = actionsCreator(useThemesStore);
